
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import WidgetNavigationMap from '../../moreCore/UI/Navigation/WidgetNavigationMap';
import OrchestraMatrixPEP from '../OrchestraMatrixPEP/OrchestraMatrixPEP';
import EvTaskRegistrationAgenda from './EvTaskRegistrationAgenda';
import EvTaskValidationAgenda from './EvTaskValidationAgenda';
import EvTaskMyTasksAgenda from './EvTaskMyTasksAgenda';
import EvTaskAssignmentAgenda from './EvTaskAssignmentAgenda';

/**
 * Home-Navigation für Orchesterdienste-Bereich
 */
class EvTask_HomeNavigation extends compose(WidgetNavigationMap<{}>) {

    


    private _openMatrix() {
        let dlg = new GenericDialog();

        // aus Projectwizard kopiert:
        let form = new OrchestraMatrixPEP();
        form.mainMenuGlobalSpaceNode = dlg.leftActionContainerNode; // hier kommt die OM-toolbar hin
        //form.directProjectId = this.entityId;

        this.UiModder.domStyle.set(form.domNode, {
            height: "800px",
            width: "100%"
        });

        this.UiModder.domStyle.set(dlg.modalDlgContentNode, {
            width: "80%"
        });

        //form.setup(this.entityData, this.bookingList.getEntityListData() as any);

        dlg.show(form,
            "EvTaskMatrix__MainTitle",
            null,
            null,
            "close");

        //dlg.keepOpen = true;
        dlg.show()

        this.UiModder.domClass.remove(dlg.leftActionContainerNode, "w3-hide");

        form.startup();
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setup({

            "EvTaskRegistrationAgenda": {
                navigationAreaName: "default",
                icon: "fas fa-user-check",
                label: "EvTaskRegistration__MainTitle",
                colorClass: "w3-purple",
                roles: ["EvTask_Registration"],
                featurepath: "EvTask/RegistrationAgenda",
                targetWidget: EvTaskRegistrationAgenda,
                dojoProps: [{
                    name: "widgetTemplateVariant",
                    value: "datepickerTopLeft"
                }]
            },


            "EvTaskValidationAgenda": {
                navigationAreaName: "default",
                icon: "fas fa-user-clock",
                label: "EvTask__ValidationAgenda_MainTitle",
                colorClass: "w3-deep-purple",
                roles: ["EvTask_Validation"],
                featurepath: "EvTask/ValidationAgenda",
                targetWidget: EvTaskValidationAgenda,
                dojoProps: [{
                    name: "widgetTemplateVariant",
                    value: "datepickerTopLeft"
                }]

            },

            "EvTaskAssignmentAgenda": {
                label: "EvTaskAssignmentAgenda_MainTitle",
                navigationAreaName: "default",
                icon: "fas fa-user-tag",
                roles: ["EvTask_EmployeeAssignmentAgenda"],
                featurepath: "EvTask/AssignmentAgenda",
                targetWidget: EvTaskAssignmentAgenda,
                dojoProps: [{
                    name: "widgetTemplateVariant",
                    value: "datepickerTwoThird"
                }]
            },


            "EvTaskMyTasksAgenda": {
                navigationAreaName: "default",
                icon: "fas fa-clipboard-list",
                label: "EvTask__MyTasksAgenda_MainTitle",
                colorClass: "w3-indigo",
                roles: ["EvTask_MyTasks"],
                featurepath: "EvTask/MyTasksAgenda",
                targetWidget: EvTaskMyTasksAgenda,
                 dojoProps: [{
                    name: "widgetTemplateVariant",
                     value: "datepickerTwoThird"
                }]
            },

           
            "EvTaskMatrix": {
                navigationAreaName: "default",
                icon: "fas fa-border-none",//"fas fa-pencil-ruler",
                label: "EvTaskMatrix__MainTitle",
                colorClass: "w3-blue",
                roles: ["EvTaskMatrix"],
                //featurepath: "OpusManagement/OpusPerformanceAgenda",
                //targetWidget: OrchestraMatrix,
                //target: "/Home/OM"
                callback: lang.hitch(this, this._openMatrix)
            }
        },
        // SORTIERUNG DER BEREICHE
        {
            "default": {
                order: 1,
                label: "General_Label_EvTasks"
            }            
        }
        );
    }
}

export default mdsWidget(EvTask_HomeNavigation);